
import React, { useEffect, useRef } from "react";
import "./banner.scss";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Header from "../Header/Header";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);



const Banner = () => {
  const textRef = useRef(null);
  const paraRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {

    const tl = gsap.timeline();

    gsap.set(textRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });

    tl.to(textRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(
      paraRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  }, []);

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(buttonRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });


    tl.to(buttonRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 0.5,
      ease: "power2.out",
    })

      .to(buttonRef.current, {
        rotateY: 360,
        duration: 0.8,
        ease: "power2.inOut",
      });
  }, []);

  useEffect(() => {
    gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
      opacity: 0,
      y: 10,
      duration: 0.6,
      stagger: 0.2,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(".fade-element", { x: 100, opacity: 0, }, { x: 0, opacity: 1, duration: 1 });
  }, []);

  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://tomi.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Features",
        "item": "https://tomi.com/feature"
      }
    ]
  };

  // Inject JSON-LD for SEO
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <section className="bannermainprnt">
        <Header />
        <div className="custom-container ">

          <div className="heromain">
            <div className="heroleftseaction">
              <div className="textherobanner">

                <nav aria-label="breadcrumb"> 
                  <Breadcrumb className="breadcrumbprnt">
                    <Breadcrumb.Item className="breadvrumbcnt" href="/">
                      Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                      className="breadvrumbcntactive"
                    >
                      Features
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </nav>
                <h1 ref={textRef}>TOMI: The Complete Web3 Ecosystem</h1>
                <p ref={paraRef}>Connect, transact, and manage your digital identity with complete privacy and control</p>

              </div>
              <a ref={buttonRef} className="herofeaturebannerbtn primerybtn" data-bs-toggle="modal"
                data-bs-target="#exampleModal" href="">
                Get Early Access
              </a>
            </div>
            <div className="herorightseaction displaynoneonmobile">
              <img className="img-fluid fade-element" src="\assets\tomiherobg.png" alt="TOMI: The Complete Web3 Ecosystem img" />
              <div className="mainmobile">
              <video className="innervideo"
                    muted="muted" playsinline="playsinline"
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo">
                    <source src="/assets/featureone.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className="herorightseaction d-none displayshowonmobile">
              <img className="img-fluid fade-element d-block m-auto" src="\assets\tomiherobg.png" alt="TOMI: The Complete Web3 Ecosystem img" />
              <div className="mainmobile">
              <video className="innervideo"
                    muted="muted" playsinline="playsinline"
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo">
                    <source src="/assets/featureone.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section >


    </>
  );
};

export default Banner;
